import { ref, watch } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
import { addSubScenarioFetch } from '@/api/sandbox';
import { reportEvent } from '@/common';
import { message } from 'ant-design-vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AddConfigModal',
  props: {
    modalVisible: {
      type: Boolean
    },
    editItem: null,
    scenarioList: null
  },
  emits: ['update:modalVisible', 'updateList'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const rules = {
      scenarioId: [{
        required: true,
        message: '请选择所属场景分类',
        trigger: 'blur'
      }],
      subScenarioCode: [{
        required: true,
        message: '请输入场景code',
        trigger: 'blur'
      }],
      subScenarioName: [{
        required: true,
        message: '请输入场景分类名称',
        trigger: 'blur'
      }],
      sort: [{
        required: true,
        message: '请输入排序',
        trigger: 'blur'
      }],
      remark: [{
        required: false,
        message: '请输入备注',
        trigger: 'blur'
      }]
    };
    const configForm = ref({
      scenarioId: undefined,
      subScenarioCode: '',
      subScenarioName: '',
      sort: 1,
      remark: ''
    });
    const configRef = ref(null);
    const loading = ref(false); // loading状态
    const closeModal = () => {
      var _configRef$value;
      configForm.value = {
        scenarioId: undefined,
        subScenarioCode: '',
        subScenarioName: '',
        sort: 1,
        remark: ''
      };
      (_configRef$value = configRef.value) === null || _configRef$value === void 0 || _configRef$value.resetFields();
      emit('update:modalVisible', false);
    };
    const handleOk = () => {
      configRef.value.validate().then(async () => {
        // 使用批量接口处理所有情况
        const params = {
          scenarioId: configForm.value.scenarioId,
          subScenarioCode: configForm.value.subScenarioCode,
          subScenarioName: configForm.value.subScenarioName,
          sort: configForm.value.sort,
          remark: configForm.value.remark
        };
        const isEdit = configForm.value.subScenarioId;
        const messageTxt = isEdit ? '编辑成功' : '添加成功';
        if (isEdit) {
          params.subScenarioId = configForm.value.subScenarioId;
        }
        try {
          loading.value = true;
          const {
            code
          } = await addSubScenarioFetch(params);
          if (code === '0000') {
            message.success(messageTxt);
            emit('updateList');
            closeModal();
            reportEvent({
              eventName: 'element_use',
              properties: {
                ui_name: '场景配置',
                element_name: messageTxt
              }
            });
          }
        } catch (error) {} finally {
          loading.value = false;
        }
      });
    };
    watch(() => props.editItem, n => {
      var _Object$keys;
      if (n && (_Object$keys = Object.keys(n)) !== null && _Object$keys !== void 0 && _Object$keys.length) {
        configForm.value = {
          ...n
        };
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_a_select_option = _resolveComponent("a-select-option");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_input_number = _resolveComponent("a-input-number");
      const _component_a_textarea = _resolveComponent("a-textarea");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        title: "添加场景",
        centered: "",
        open: __props.modalVisible,
        onCancel: closeModal,
        onOk: handleOk,
        "confirm-loading": loading.value,
        "ok-text": "保存",
        width: "540px"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form, {
          model: configForm.value,
          layout: "vertical",
          ref_key: "configRef",
          ref: configRef,
          rules: rules
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            label: "所属场景分类",
            name: "scenarioId",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_a_select, {
              value: configForm.value.scenarioId,
              "onUpdate:value": _cache[0] || (_cache[0] = $event => configForm.value.scenarioId = $event),
              placeholder: "请选择所属场景分类"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.scenarioList, item => {
                return _openBlock(), _createBlock(_component_a_select_option, {
                  key: item.scenarioId,
                  value: item.scenarioId,
                  label: item.scenarioName
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item.scenarioName), 1)]),
                  _: 2
                }, 1032, ["value", "label"]);
              }), 128))]),
              _: 1
            }, 8, ["value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "场景code",
            name: "subScenarioCode",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: configForm.value.subScenarioCode,
              "onUpdate:value": _cache[1] || (_cache[1] = $event => configForm.value.subScenarioCode = $event),
              valueModifiers: {
                trim: true
              },
              placeholder: "请输入场景code"
            }, null, 8, ["value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "场景名称",
            name: "subScenarioName",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: configForm.value.subScenarioName,
              "onUpdate:value": _cache[2] || (_cache[2] = $event => configForm.value.subScenarioName = $event),
              valueModifiers: {
                trim: true
              },
              placeholder: "请输入场景名称"
            }, null, 8, ["value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "排序",
            name: "sort",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input_number, {
              value: configForm.value.sort,
              "onUpdate:value": _cache[3] || (_cache[3] = $event => configForm.value.sort = $event),
              min: 0,
              precision: 0,
              placeholder: "请输入排序",
              style: {
                "width": "100%"
              }
            }, null, 8, ["value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "备注",
            name: "remark"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_textarea, {
              value: configForm.value.remark,
              "onUpdate:value": _cache[4] || (_cache[4] = $event => configForm.value.remark = $event),
              valueModifiers: {
                trim: true
              },
              rows: 2,
              placeholder: "请输入备注"
            }, null, 8, ["value"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["open", "confirm-loading"]);
    };
  }
});